import { Grid, Box, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DescriptionIcon from '@mui/icons-material/Description';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import GroupIcon from '@mui/icons-material/Group';
import { ReactNode, useContext } from 'react';
import { UserContext } from '../../contexts/UserContext.tsx';
import { IDashboard } from '../../interfaces/dashboard.ts';

interface IInfoBox {
	title: string;
	value: number;
	icon: ReactNode;
}

const DashboardHeader = ({ data }: { data: IDashboard | undefined }) => {
	const { t } = useTranslation();

	const { user } = useContext(UserContext);

	const infoAdvertiser: IInfoBox[] = [
		{
			title: t('campaigns_implemented'),
			value: data?.campaignsCount ?? 0,
			icon: <LocalMallIcon className="text-primary-main" />,
		},
		{
			title: t('number_visits_campaigns'),
			value: data?.campaignsQueueUpCount ?? 0,
			icon: <GroupIcon className="text-secondary-main" />,
		},
		{
			title: t('total_requests_views'),
			value: +(data?.campaignViewsCount ?? 0),
			icon: <InsertChartIcon className="text-primary-main" />,
		},
		{
			title: t('number_studio_requests'),
			value: data?.studioRequestsCount ?? 0,
			icon: <DescriptionIcon className="text-secondary-main" />,
		},
	];

	const infoAdReceiver: IInfoBox[] = [
		{
			title: t('number_orders'),
			value: data?.campaignsReceivedCount ?? 0,
			icon: <LocalMallIcon className="text-primary-main" />,
		},
		{
			title: t('total-accounts'),
			value: data?.mediaEntitiesCount ?? 0,
			icon: <GroupIcon className="text-secondary-main" />,
		},
		{
			title: t('total-income'),
			value: data?.revenueSum ?? 0,
			icon: <InsertChartIcon className="text-primary-main" />,
		},
		{
			title: t('number_campaigns_pending_approval'),
			value: data?.campaignsReceivedPendingCount ?? 0,
			icon: <DescriptionIcon className="text-secondary-main" />,
		},
	];

	return (
		<Grid container className="flex w-full items-center justify-center gap-3 bg-dashboard-header-background bg-cover bg-no-repeat px-4 py-6">
			{[...(user?.is_advertiser === 1 ? infoAdvertiser : []), ...(user?.is_ad_receiver === 1 ? infoAdReceiver : [])].map((item, i) => (
				<Grid key={i} item xs={3} className="flex h-[118px] min-w-52 max-w-96 items-center justify-start rounded-lg border border-background-paper bg-[#FFFFFF4D] p-4 xl:max-w-60">
					<Box className="ml-8 flex h-12 w-12 items-center justify-center rounded-lg bg-background-paper bg-opacity-50">{item.icon}</Box>
					<Box className="flex flex-col gap-y-2">
						<span className="text-sm font-medium text-grey-700">{item.title ?? <Skeleton />}</span>
						<span className="text-black-100 text-3xl">{item.value}</span>
					</Box>
				</Grid>
			))}
		</Grid>
	);
};

export default DashboardHeader;
